/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA
 */

export const BULK_ACTIONS_ENTITY_TYPES = {
    USER: 'portalUser',
    GROUP: 'portalGroups',
    SESSION: 'portalSessions'
};

export const BULK_ACTION_KEYS = {
    EDIT: 'bulk-edit',
    DELETE: 'bulk-delete'
};

export const BULK_OPERATIONS_CONFIG_PERMISSION = { resource: 'portal.bulk-operations', scopes: ['create'] };

export const BULK_ACTION_PERMISSIONS = {
    [BULK_ACTION_KEYS.EDIT]: {
        [BULK_ACTIONS_ENTITY_TYPES.USER]: { resource: 'bulk-edit.user', scopes: ['create'] },
        [BULK_ACTIONS_ENTITY_TYPES.GROUP]: { resource: 'bulk-edit.groups', scopes: ['create'] },
        [BULK_ACTIONS_ENTITY_TYPES.SESSION]: { resource: 'bulk-edit.sessions', scopes: ['create'] }
    },
    [BULK_ACTION_KEYS.DELETE]: {
        [BULK_ACTIONS_ENTITY_TYPES.SESSION]: { resource: 'bulk-delete.sessions', scopes: ['create'] }
    }
};

export const BULK_ACTIONS_ALLOWED_ENTITY_TYPES = new Set(Object.values(BULK_ACTIONS_ENTITY_TYPES));
